import { TrelloTemplateModel } from "../../models";

import { mock$AssetModel } from "./mock-asset";

export function mockTrelloTemplateModel({
    id = "trello-template-1234",
    type = "trelloTemplate",
    locale = "en",
    content = mockTrelloTemplateModelContent()
}: Partial<TrelloTemplateModel> = {}): TrelloTemplateModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type TrelloTemplateModelContent = TrelloTemplateModel["content"];

export function mockTrelloTemplateModelContent({
    entryTitle = "Example Template",
    title = "Title here",
    description = "Lorem ipsum sit dolor amet adepiscing consecutor qui",
    avatar = mock$AssetModel(),
    url = "https://trello.com/templates/abc123",
    ...optionals
}: Partial<TrelloTemplateModelContent> = {}): TrelloTemplateModelContent {
    return {
        entryTitle,
        title,
        description,
        avatar,
        url,
        ...optionals
    };
}
